var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card", staticStyle: { width: "100%" } },
      [
        _c("post-owner-info", {
          attrs: {
            data: _vm.data,
            isServiceAdmin: _vm.isServiceAdmin,
            user_id: _vm.user_id,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn-group mt-05",
            staticStyle: { right: "5px", position: "absolute" },
          },
          [
            _c("span", {
              staticClass: "font-small-1 text-light",
              staticStyle: { "margin-top": "4px" },
              domProps: { textContent: _vm._s(_vm.ago) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "dropdownMenuButton200" },
                },
                [
                  _vm.isServiceAdmin === true ||
                  _vm.user_id === _vm.data.module.owner.id ||
                  _vm.isAdmin === true
                    ? _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.destroy.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "feather icon-trash-2" }),
                            _vm._v(
                              _vm._s(
                                _vm.__("question.form.links.delete_question")
                              )
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item danger",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.report.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "feather icon-alert-triangle" }),
                      _vm._v(
                        _vm._s(_vm.__("question.form.links.report_question"))
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-1 mr-1 pt-1 pb-1 mb-0 border-top border-bottom" },
          [
            _c("div", { staticClass: "breakAll" }, [
              _c(
                "a",
                {
                  staticClass: "font-medium-3 text-dark text-bold-700",
                  attrs: { href: "/member/question/" + _vm.data.module.slug },
                },
                [
                  _vm._v(
                    " " + _vm._s(this.$options.filters.nl2br(_vm.title, true))
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              directives: [{ name: "linkified", rawName: "v-linkified" }],
              staticClass: "breakAll pt-05 pb-05",
              domProps: {
                innerHTML: _vm._s(this.$options.filters.nl2br(_vm.body, true)),
              },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.data.groups !== undefined && _vm.data.groups.length > 0
          ? _c("div", { staticClass: "p-1" }, [
              _c(
                "a",
                { attrs: { href: "/member/group/" + _vm.data.groups[0].slug } },
                [
                  _c("div", { staticClass: "card text-white mb-0" }, [
                    _c("img", {
                      staticClass: "card-img img-fluid",
                      staticStyle: { height: "3rem" },
                      attrs: {
                        src:
                          _vm.data.groups[0].group_cover == null
                            ? "/images/cover.jpg"
                            : _vm.data.groups[0].group_cover.url,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "text-white mb-0",
                            staticStyle: { "line-height": "1rem" },
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.__("globals.posted_in")) + " "),
                            ]),
                            _vm._v(" " + _vm._s(_vm.data.groups[0].title)),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          { staticClass: "btn-sm btn-outline-white ml-auto" },
                          [
                            _vm._v(_vm._s(_vm.__("globals.view_group")) + " "),
                            _c("i", {
                              staticClass: "feather icon-chevron-right",
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ])
          : _vm.data.suppliers !== undefined && _vm.data.suppliers.length > 0
          ? _c("div", { staticClass: "p-1" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "/member/supplier/" + _vm.data.suppliers[0].slug,
                  },
                },
                [
                  _c("div", { staticClass: "card text-white mb-0" }, [
                    _c("img", {
                      staticClass: "card-img img-fluid",
                      staticStyle: { height: "3rem" },
                      attrs: {
                        src:
                          _vm.data.suppliers[0].supplier_cover_image == null
                            ? "/images/cover.jpg"
                            : _vm.data.suppliers[0].supplier_cover_image.url,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "text-white mb-0",
                            staticStyle: { "line-height": "1rem" },
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.__("globals.posted_to")) + " "),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.data.suppliers[0].title) + " "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          { staticClass: "btn-sm btn-outline-white ml-auto" },
                          [
                            _vm._v(_vm._s(_vm.__("globals.view_page")) + " "),
                            _c("i", {
                              staticClass: "feather icon-chevron-right",
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto p-05" }, [
          _c(
            "a",
            {
              staticClass: "ml-auto text-bold-700 font-small-3",
              attrs: { href: "/member/question/" + _vm.data.module.slug },
            },
            [
              _vm._v(_vm._s(_vm.__("question.view_this_question")) + " "),
              _c("i", { staticClass: "feather icon-chevron-right" }),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-sm btn-outline-light dropdown-toggle ",
        staticStyle: { border: "none" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-chevron-circle-down mr-0" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }